import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import styles from './grid-sidebar-sellable-item.css'

const GridSidebarSellableItem = ({ sellableItem, onEdit, onRemove }) => (
  <div styleName="container" style={{ backgroundColor: sellableItem.color }}>
    <div styleName="header">
      <div styleName="label" title={sellableItem.name}>
        {sellableItem.name}
      </div>
      <div styleName="edit" onClick={onEdit}>✎</div>
      <div styleName="remove" onClick={onRemove}>x</div>
    </div>
    <div styleName="price">
      {sellableItem.quantity} × £{sellableItem.salePrice}
    </div>
  </div>
)

GridSidebarSellableItem.propTypes = {
  onEdit: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  sellableItem: PropTypes.object.isRequired,
}

export default CSSModules(GridSidebarSellableItem, styles)



/** WEBPACK FOOTER **
 ** ./src/components/grid-sidebar/grid-sidebar-sellable-item/grid-sidebar-sellable-item.js
 **/